import request from '../../http/request'

export const getWriteOffConfigBatchList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/batchConfigPage`, params)
}

export const getWriteOffNFCBatchNumberList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/batchPage`, params)
}

export const addWriteOffNFCBatchNumber = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/batchSave`, params, {
    hiddenError: true
  })
}

export const addWriteOffNFCBatchNumberUpdate = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/batchEdit`, params, {
    hiddenError: true
  })
}

export const changeWriteOffNFCBatchNumberStatus = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/updateBatchStatus`, params)
}

export const findPlantModules = param => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/getWriteOffConfigPlantList`, param)
}

export const findBatchNoModules = () => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/getWriteOffBatchNoList`)
}

export const findUndoWriteOffBatchNoList = () => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/getUndoWriteOffBatchNoList`)
}

export const findUndoOperatorList = () => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/getUndoOperatorList`)
}

export const findBatchNumberByPlant = param => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/queryBatchNosByPlant`, param)
}

export const scanBatchDetail = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/scanBatchDetail`, params)
}

export const withdrawBatchDetail = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/withdrawBatchDetail`, params)
}

export const queryUndoRecordPage = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/queryUndoRecordPage`, params)
}

export const exportUndoRecord = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/exportUndoRecord`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getProductCodeByUpc = param => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/queryProductInfoByUpc`, param)
}

export const downloadBatchInfo = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/downloadBatchInfo`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getWriteOffNFCBatchNumberDetailList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/queryBatchDetail`, params)
}

export const uploadWriteOffNFCBatchNo = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/submitDisableUidList`, params, {
    hiddenError: true
  })
}

export const disableWriteOffNFCBatchNumberStatus = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/writeOff/disableBatch`, params)
}
